export default "__VITE_ASSET__DyHrvCHE__"